module.exports = __webpack_public_path__ + "40036e169666923e461bd2f39d6e99b9.png";